import { useState, useEffect } from "react";
import { System } from "../../store/types";
import { useUnitsAPI } from "../../hooks/api/use-unitsAPI";
import { UNIT_SYSTEM_CHANGED_EVENT } from "../../hooks/use-logChartUnitConversion";
import { DropdownChangeEvent } from "primereact/dropdown";
import { StyledDropdown } from "./UnitsSystemToggle.styles";

const UnitsSystemToggler: React.FC = () => {
  const [selectedSystem, setSelectedSystem] = useState<System>();
  const { systems } = useUnitsAPI({ fetchSystems: true });
  const storedUnitSystemId = localStorage.getItem("unitSystemId") as
    | string
    | null;

  useEffect(() => {
    if (systems) {
      if (storedUnitSystemId && storedUnitSystemId !== undefined) {
        let _system = systems.find(
          (system: System) => system.id.toString() === storedUnitSystemId
        );
        setSelectedSystem(_system);
        return;
      }

      let _defaultSystem = systems.find((system) => system.label === "SI");
      setSelectedSystem(_defaultSystem);
    }
  }, [systems, storedUnitSystemId]);

  const handleSubmit = (e: DropdownChangeEvent) => {
    if (!e.value) return;
    setSelectedSystem(e.value);

    localStorage.setItem("unitSystemId", e.value.id.toString());
    window.dispatchEvent(new Event(UNIT_SYSTEM_CHANGED_EVENT));
  };

  return (
    <StyledDropdown
      value={selectedSystem}
      onChange={handleSubmit}
      options={systems}
      placeholder="Система измерений"
    />
  );
};

export default UnitsSystemToggler;
